module.exports = __webpack_public_path__ + "img/img_out_offering_fixed_in2020.d8b7ee63.png";